import type { Tag } from '@/types';

interface TagBarProps {
  tags: Tag[];
  activeId: number;
  onToggle: (id: number) => void;
}

export function TagBar({ tags, activeId, onToggle }: TagBarProps) {
  if (tags.length === 0) {
    return null;
  }

  return (
    <div className="shrink-0 flex gap-1.5 kiosk:gap-[1vw] px-4 kiosk:px-[3vw] pb-2 kiosk:pb-[1.5vw] overflow-x-auto">
      {tags.map((tag) => {
        const isActive = tag.id === activeId;
        return (
          <button
            key={tag.id}
            type="button"
            onClick={() => onToggle(tag.id)}
            className={`flex-none text-kiosk-xs px-3 py-1.5 kiosk:px-[1.8vw] kiosk:py-[1vw] min-h-[34px] kiosk:min-h-0 rounded-full border transition-colors duration-150 ${
              isActive
                ? 'bg-kiosk-accent2 border-kiosk-accent2 text-white font-semibold'
                : 'border-kiosk-border text-kiosk-muted hover:border-kiosk-accent2'
            }`}
          >
            {tag.name ?? tag.slug}
          </button>
        );
      })}
    </div>
  );
}
